<template>
  <div
    :data-tint="event.extendedProps.tint"
    class="border-primary bg-primary/40 text-contrast-primary flex h-full w-full flex-row gap-0.5 overflow-hidden rounded-sm border-l-4 p-1 shadow-lg"
    :class="editable ? '' : 'bg-hashure'"
  >
    <div
      v-if="getTintFuneralHome"
      class="bg-primary w-1 shrink-0 rounded-sm"
      :data-tint="getTintFuneralHome"
    >
      &nbsp;
    </div>
    <div
      v-if="under30min"
      class="flex flex-1 flex-col leading-tight"
      :class="[editable ? '' : 'text-white-800 font-bold']"
    >
      <div class="font-bold text-black">{{ timeText }} {{ eventTitle }}</div>
      <span class="capitalize-first font-bold text-black">
        {{ event.extendedProps.full_name }}
      </span>
    </div>
    <div v-else class="flex flex-row flex-wrap gap-x-4">
      <div
        class="flex flex-1 flex-col leading-tight"
        :class="[editable ? '' : 'text-white-800 font-bold']"
      >
        <div class="font-semibold text-black">{{ timeText }}</div>
        <div class="font-semibold text-black">
          {{ eventTitle }}
        </div>
        <span class="capitalize-first font-bold text-black">
          {{ event.extendedProps.full_name }}
        </span>
      </div>
      <div v-if="displayUsersSelector" class="flex">
        <EventUserSelector
          :event="localEvent"
          avatar-size="extra-small"
          @click.stop
          @update:event="onEventUpdate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EventUserSelector from '@c/Event/EventUserSelector.vue'

export default {
  name: 'EventComponent',
  components: { EventUserSelector },
  props: {
    event: {
      type: Object,
      required: true
    },
    timeText: {
      type: String,
      required: true
    },
    displayUsersSelector: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editable: true,
      localEvent: this.event.extendedProps.event ?? null
    }
  },
  computed: {
    ...mapGetters({
      getFuneralHome: 'metadata/getFuneralHomeMetadata',
      metadata: 'metadata/getInitialMetadata',
      themeColors: 'metadata/getThemeColors',
      dossier: 'dossier/getDossier'
    }),
    eventTitle() {
      const type = this.event.extendedProps?.type
      const title = this.event.extendedProps?.title

      if (type === 'OTH' && title) {
        return title
      }
      if (type === 'BUR' && this.event.extendedProps?.burial_type) {
        let burial_prefix = ''
        if (this.event.extendedProps.dossier_cremation) {
          burial_prefix = this.capitalizeFirst(this.$t('attributes.burial_type'))
        } else {
          burial_prefix = this.capitalizeFirst(this.$t('attributes.burial'))
        }
        return burial_prefix + ' - ' + this.metadata?.models?.list_items?.burial_types?.find(
          (type) => type.id === this.event.extendedProps.burial_type
        )?.name
      }

      return this.$t(`enums.event.type.${type}`)
    },
    under30min() {
      return (
        this.event.end &&
        (this.event.end.getTime() - this.event.start.getTime()) / 1000 <=
          30 * 60
      )
    },
    getTintFuneralHome() {
      if (!this.funeralHome) {
        return 'default'
      }
      return this.funeralHome.color
    },
    funeralHome() {
      if (this.event?.extendedProps?.funeral_home_id) {
        return this.getFuneralHome(this.event.extendedProps.funeral_home_id)
      }
      return null
    }
  },
  watch: {
    'event.extendedProps.event'(newVal) {
      this.localEvent = newVal ?? null
    }
  },
  mounted() {
    if (this.event._def.extendedProps.draggable === undefined) {
      return
    }
    this.editable = this.event._def.extendedProps.draggable
  },
  methods: {
    capitalizeFirst(text) {
      if (!text) return ''
      return text.charAt(0).toUpperCase() + text.slice(1)
    },
    onEventUpdate(val) {
      this.localEvent = val
      // Mutation directe intentionnelle : on met à jour l'objet extendedProps
      // partagé par FullCalendar pour que le watcher sur event.extendedProps.event
      // ne réinitialise pas localEvent avec une valeur périmée lors d'un re-render
      // FullCalendar (drag, resize…).
      // On n'utilise PAS event.setExtendedProp() car celui-ci notifie le store
      // interne de FullCalendar et provoque un re-render calendrier inutile.
      // extendedProps étant un objet plain partagé par référence, la mutation
      // directe persiste sans déclencher de cycle de rendu.
      if (this.event.extendedProps) {
        // eslint-disable-next-line vue/no-mutating-props
        this.event.extendedProps.event = val
      }
    }
  }
}
</script>

<style scoped>
.bg-hashure {
  background-image: linear-gradient(
    45deg,
    #ccc 25%,
    transparent 25%,
    transparent 50%,
    #ccc 50%,
    #ccc 75%,
    transparent 75%,
    transparent
  );
  background-size: 20px 20px;
}
</style>
